// src/components/ManifestLink.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Компонент для динамического обновления <link rel="manifest">
 * в зависимости от текущего slug проекта
 */
function ManifestLink() {
  const location = useLocation();

  useEffect(() => {
    // Извлекаем slug из пути /p/:slug/*
    const match = location.pathname.match(/^\/p\/([^/]+)/);
    const slug = match ? match[1] : null;

    // Находим или создаем элемент <link rel="manifest">
    let link = document.querySelector('link[rel="manifest"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }

    // Устанавливаем href в зависимости от наличия slug
    if (slug) {
      // Для проектных страниц - используем динамический манифест
      link.href = `/p/${slug}/manifest.json`;
    } else {
      // Для глобальных страниц (/, /superadmin, /support) - используем дефолтный манифест
      // или можно вообще убрать для админов
      link.href = '/manifest.json';
    }

    console.log('[ManifestLink] Updated manifest href:', link.href, 'for slug:', slug);
  }, [location.pathname]);

  // Этот компонент не рендерит ничего в DOM
  return null;
}

export default ManifestLink;

